import { Component, Input } from "@angular/core";

@Component({
    selector: "separate-audio-files",
    templateUrl: "./separate-audio-files.component.html",
})
export class SeparateAudioFilesComponent {
    @Input("fieldProp") public separateAudioFilesFieldProp: string;
    @Input("fieldLabel") public separateAudioFilesFieldLabel: string;
}
